<template>
  <div class="layout">
    <MainHeader v-if="$route.name != 'systemIndex' && $route.name != 'zdsyNewsDetail'&&!isMobile"></MainHeader>
<!--    <div class="iv-home" v-if="$route.name != 'systemIndex' && $route.name != 'zdsyNewsDetail' &&!isMobile">-->
<!--      <div class="iv-home-content iv-main-width ">-->
<!--        <div class="iv-home-router iv-main-width ">-->
         <div v-show="false"><Tab @nav-data="getNavData"></Tab></div>
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- <MainBread></MainBread> -->
    <div class="iv-home-content">
      <!-- <MainRouter></MainRouter> -->
      <router-view :navData="navData"></router-view>
    </div>
  </div>
</template>
<script>
import MainBread from './main-breadcrumb'
import MainRouter from './main-router'
import MainHeader from '../news-core/header'
import Tab from './new-tab.vue'

export default {
  data() {
    return {
      navData: {},
      isMobile:false,//判断是不是手机访问
    }
  },
  components: {
    MainBread,
    MainRouter,
    MainHeader,
    Tab
  },
  created() {
    this.isMobile = this.$route.query.device == 'mobile'?true:false
    // if(this.$route.query.accessToken){
    //   this.isMobile=true
    // }
  },
  watch: {
    $route(val) {
      // IE下强制GC
      if (/trident/i.test(navigator.userAgent) && window.CollectGarbage) {
        this.$nextTick(() => {
          window.CollectGarbage()
        })
      }
    }
  },
  computed: {
    rotateIcon() {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ]
    }
  },
  methods: {
    getNavData(data) {
      this.navData = data
    }
  }
}
</script>

<style lang="scss">
/*全局样式注入*/
@import '@/assets/css/blue/index.scss';

body, html, #app {
  #app {
    font-family: 'PingFang SC', 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #F5F7FA;
    height: 100vh !important;
    overflow: hidden;
  }

  #apps {
    font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: rgba(255, 255, 255, 1);
    height: 100vh !important;
  }
}

body {
  overflow-x: hidden !important;
  scrollbar-width: thin;
}

.iv-app-contents {
  background: rgba(255, 255, 255, 1);
  overflow-y: auto;
  margin-top: 40px;
  // height: calc(100vh - 64px) !important;
  height: 100vh !important;
}

.iv-all-height {
  height: 100vh;
  margin-top: 0;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #c2c2c2;
}

::-webkit-scrollbar-track {
  border-radius: 6px;
  background: rgba(250, 250, 250, .9);
}
</style>

<style lang="scss" scoped>
.layout {
  background: #F7F7F7;
  box-sizing: border-box;
  height: 100%;
}

.iv-home-content {
  box-sizing: border-box;
  height: calc(100% - 48px);
  padding-top: 65px;
}

.iv-home {
  box-shadow: 0px 8px 8px 0px rgba(98, 98, 98, .05);
  height: 48px;
  background: #F7F7F7;

  /deep/ .iv-home-content {
    box-sizing: border-box;
    height: 100%;

    .iv-home-router {
      .iv-home-list {
        width: 1200px;

        .ivu-tabs-bar {
          width: 1200px;
          border-bottom: none;

          .nav-text {
            width: 100%;
            border-bottom: 0px solid #fff;
            display: flex;
            justify-content: space-between;

            .ivu-tabs-ink-bar {
              width: 30px !important;
              left: 45px;
              display: none !important;
            }

            .ivu-tabs-tab {
              padding: 12px 2px;
              flex:1;
              // width: 100px !important;
              text-align: center;
            }
          }
        }
      }

      .iv-home-xie {
        margin-top: 30px;
        color: rgba(0, 0, 0, .45);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;

        .iv-pointer {
          color: rgba(0, 0, 0, .45);
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        .iv-pointer {
          color: rgba(0, 0, 0, .45);
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
    }

  }
}

.iv-home::before {
  clear: both;
  content: '';
}

@media screen and (min-width: 1366px) {
  /deep/ .iv-home-content {
    .iv-home-list {
      width: 1200px !important;

      .ivu-tabs-bar {
        width: 1200px !important;

        .nav-text {
          width: 1200px !important;
        }
      }
    }
  }
}
</style>
